import { useEffect, useMemo, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { setServices, setTrainers, setDates } from '../http/clubsApi';
import {
  setFilialType,
  setIdFilial,
  pushDateArr,
  clearDateArr,
  setClassesCount,
} from '../redux/slices/clubsSlice';
import { useGetClientQuery } from '@/queries/useGetClientQuery';
import { useQueryClient } from '@tanstack/react-query';
import { getClientQueryKey, getAppointmentsQueryKey, getClubsQueryKey } from '@/utils/queryKeys';
import { getCookie } from '@/utils/cookies';

export const useHome = () => {
  const dispatch = useDispatch();
  const { clubName } = useSelector((state: any) => state.clubs);
  const [selectedClubValue, setSelectedClubValue] = useState<string>(
    localStorage.getItem('club_name') || '',
  );
  const [advertisementColor, setAdvertisementColor] = useState<string>('#E0F2FE');

  const userToken: string | null = getCookie('user_token');

  const advertisement = useSelector((state: any) => state.interfaceApp.advertisement);

  useEffect(() => {
    if (!advertisement) {
      setAdvertisementColor('#E0F2FE'); // значение по умолчанию
      return;
    }
    switch (advertisement.type) {
      case 'info':
        setAdvertisementColor('#E0F2FE');
        return;
      case 'warning':
        setAdvertisementColor('#FEF3C7');
        return;
      default:
        return;
    }
  }, [advertisement]);
  const queryClient = useQueryClient();
  const { data: clientData, isPending, error } = useGetClientQuery();

  const userName = useMemo(() => {
    if (clientData) return `${clientData.name} ${clientData.last_name}`;

    return '';
  }, [clientData]);
  const updateDataFilial = (clubName: string, idClub: string) => {
    dispatch(clearDateArr());
    if (idClub) {
      onClickListItem(clubName, idClub);
    }
  };

  const onClickListItem = async (title: string, idClub: string) => {
    try {
      localStorage.setItem('id_club', idClub);
      dispatch(setFilialType(title));
      dispatch(setIdFilial(idClub));
      dispatch(clearDateArr());

      const resTrainers = await setTrainers(idClub, userToken);
      dispatch(setClassesCount(resTrainers.data.data.length));
      const resDates = await setDates(idClub, userToken);
      const date = resDates.data.data[0];
      dispatch(pushDateArr(date));
      const resServices = await setServices(idClub, userToken);
      if (resServices.data.data.length > 0) {
        localStorage.setItem('service_id', resServices.data.data[0].id);
      }
    } catch (error) {
      console.error('Error setting trainers:', error);
    }
  };

  useEffect(() => {
    const clubs = localStorage.getItem('clubs');
    const savedIdClub = localStorage.getItem('id_club');
    const savedFilial = localStorage.getItem('club_name');
    queryClient.invalidateQueries({ queryKey: getClientQueryKey() });
    queryClient.invalidateQueries({ queryKey: getAppointmentsQueryKey() });
    queryClient.invalidateQueries({ queryKey: getClubsQueryKey() });
    if (clubs && savedIdClub && savedFilial) {
      setSelectedClubValue(savedFilial);
      updateDataFilial(savedFilial, savedIdClub);
    }
  }, []);

  useEffect(() => {
    setSelectedClubValue(localStorage.getItem('club_name'));
  }, [clubName]);

  if (isPending)
    return {
      advertisement,
      advertisementColor,
      selectedClubValue,
      updateDataFilial,
      setSelectedClubValue,
      userName: '',
    };

  if (error)
    return {
      advertisement,
      advertisementColor,
      selectedClubValue,
      updateDataFilial,
      setSelectedClubValue,
      userName: 'Ошибка загрузки имени',
    };
  return {
    advertisement,
    advertisementColor,
    selectedClubValue,
    updateDataFilial,
    setSelectedClubValue,
    userName,
  };
};
